import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import RowActions from "./RowActions";

export const defaultSelectedColumns = [
  { id: 2, field: "Name", header: "First Name" },
  { id: 3, field: "Surname", header: "Last Name" },
  { id: 17, field: "EditWaitList", header: "Status" },
  { id: 16, field: "EditChapitre", header: "Chapitre" },
  { id: 14, field: "BusLineName", header: "Bus Line Name" },
  { id: 5, field: "TripType", header: "Trip Type" },
];

const allColumns = [
  {
    label: "Personal Data", items: [
      { id: 2, field: "Name", header: "First Name" },
      { id: 3, field: "Surname", header: "Last Name" },
      { id: 4, field: "BirthDate", header: "Birth Date" },
      { id: 11, field: "Email", header: "Email" },
      { id: 12, field: "Phone", header: "Phone" },
      { id: 13, field: "Address", header: "Address" },
      { id: 13, field: "Guardian", header: "Guardian" }
    ]
  },
  {
    label: "Registration", items: [
      { id: 17, field: "EditWaitList", header: "Status" },
      { id: 8, field: "priceStr", header: "Price" },
      { id: 1, field: "RegistrationDateTime", header: "Registration Date" },
      { id: 15, field: "FamilyID", header: "Family ID" }
    ]
  },
  {
    label: "Chapitre", items: [
      { id: 16, field: "EditChapitre", header: "Chapitre" }
    ]
  },
  {
    label: "Bus", items: [
      { id: 14, field: "BusLineName", header: "Bus Line Name" },
      { id: 5, field: "TripType", header: "Trip Type" },
      { id: 7, field: "DropOffStop", header: "Drop-Off Stop" },
      { id: 6, field: "GetAboardStop", header: "Boarding Stop" }
    ]
  }
];

const downloadCSV = (data, filename) => {
  if (!data || data.length === 0) {
    console.warn("No data available to export.");
    return;
  }

  const separator = ",";
  const keys = Object.keys(data[0]);
  const csvContent = [
    keys.join(separator),
    ...data.map((row) => keys.map((key) =>
      `"${row[key] !== null && row[key] !== undefined ? row[key] : ""}"`
    ).join(separator))
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const UserListTable = ({
  users,
  title,
  emptyMessage,
  downloadFilename,
  canUpdatePrice = () => false,
  onUpdatePrice = async () => {},
  getColumnField,
  getColumnBody,
  isColumnSortable
}) => {
  const [selectedColumns, setSelectedColumns] = useState(defaultSelectedColumns);

  return (
    <>
      <div className="col-12 md:col-12 flex-row justify-content-between align-items-center">
        <h3>{title}</h3>
        <div className="p-mb-3">
          <MultiSelect
            value={selectedColumns}
            options={allColumns}
            onChange={(e) => setSelectedColumns([...e.value].sort((a, b) => a.id - b.id))}
            optionLabel="header"
            optionGroupLabel="label"
            optionGroupChildren="items"
            placeholder="Select columns"
            maxSelectedLabels={3}
            className="w-full md:w-30rem"
          />
        </div>
        <Button
          icon="pi pi-download"
          label="Download CSV"
          className="p-button-sm p-button-outlined p-button-secondary"
          onClick={() => downloadCSV(users, downloadFilename)}
        />
      </div>

      {users.length > 0 ? (
        <DataTable value={users} paginator rows={15}>
          {selectedColumns.map((col) => (
            <Column
            filter
              sortable={isColumnSortable(col)}
              key={col.id}
              field={getColumnField(col)}
              header={col.header}
              body={getColumnBody(col)}
            />
          ))}
          <Column
            header=""
            body={(rowData) => (
              <RowActions
                user={rowData}
                canUpdatePrice={canUpdatePrice(rowData)}
                onUpdatePrice={onUpdatePrice}
              />
            )}
          />
        </DataTable>
      ) : (
        <p>{emptyMessage}</p>
      )}
    </>
  );
};

export default UserListTable;
